import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ConfigOptions, ConfigService } from '@wilson/config';
import { WorktimeUtilizationDTO } from '@wilson/interfaces';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WorkTimeUtilizationsGatewayService {
  private readonly httpClient = inject(HttpClient);
  private readonly config = inject<ConfigOptions>(ConfigService);

  protected readonly path = 'v1/kpis';

  getWorkTimeUtilizations(
    userIds: string[],
    timeRange: {
      startDatetime: string;
      endDatetime: string;
    },
  ): Observable<WorktimeUtilizationDTO> {
    return this.httpClient.post<WorktimeUtilizationDTO>(
      `${this.config.host}/${this.path}/work-time-utilizations`,
      {
        userIds,
        from: timeRange.startDatetime,
        to: timeRange.endDatetime,
      },
    );
  }
}
